import React from "react";
import * as Sentry from "@sentry/react";
import { Button, Result } from "antd";

/**
 * Fallback component displayed when an error is caught by the boundary
 */
function ErrorFallback({ error, resetError }) {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <Result
        status="error"
        title="Something went wrong"
        subTitle="We've been notified and are working on a fix. Please try refreshing the page."
        extra={[
          <Button
            type="primary"
            key="refresh"
            onClick={() => window.location.reload()}
            style={{ backgroundColor: "black" }}
          >
            Refresh Page
          </Button>,
          <Button key="home" onClick={() => (window.location.href = "/")}>
            Go to Homepage
          </Button>,
        ]}
      />
    </div>
  );
}

/**
 * Sentry Error Boundary wrapper component
 * Catches JavaScript errors in child components and reports them to Sentry
 */
function SentryErrorBoundary({ children, fallback }) {
  return (
    <Sentry.ErrorBoundary
      fallback={fallback || ErrorFallback}
      onError={(error, componentStack) => {
        // Additional error context can be added here
        Sentry.setContext("component", {
          componentStack: componentStack,
        });
      }}
      showDialog={false}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}

export default SentryErrorBoundary;
